import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { resolveContent } from '@nu-art/ts-common';
export const Component_ContentFallback = (props) => {
    return _jsx(_Fragment, { children: resolveContent(props.forceFallback ? props.fallback : props.content) });
};
//# sourceMappingURL=Component_ContentFallback.js.map